var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuncLocTopLeftMedium({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 80,
    viewBox: "0 0 123 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.025 28.9679C67.7789 28.8376 77.911 28.6421 84.6654 28.5118L89.6728 1.09286C80.3878 1.27201 75.3193 1.36871 65.188 1.56529L61.025 28.9679ZM30.1702 46.5178C28.9416 29.5857 38.2275 28.3864 54.4942 29.0926L57.5901 1.71183C24.6615 1.36845 -1.50931 3.98933 0.283534 52.8459L30.1702 46.5178ZM30.224 71.6821C29.8927 66.2549 30.193 58.7403 30.1856 53.7074L0.298919 60.0361C0.317148 68.5524 0.323559 71.5401 0.34048 79.4487L30.224 71.6821Z",
    fill: "url(#paint0_linear_5837_4336)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.9478 28.3713C98.7017 28.241 110.725 28.009 117.48 27.8787L122.488 0.459681C113.203 0.638835 107.404 0.749646 97.2723 0.946228L91.9478 28.3713Z",
    fill: "url(#paint1_linear_5837_4336)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5837_4336",
    x1: 189.915,
    y1: -42.4121,
    x2: 18.2741,
    y2: 111.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5837_4336",
    x1: 189.915,
    y1: -42.4121,
    x2: 18.2741,
    y2: 111.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuncLocTopLeftMedium);
export default __webpack_public_path__ + "static/media/func-loc-top-left-medium.091f4c60ea3e26934a928b252412d4a4.svg";
export { ForwardRef as ReactComponent };